import { connect } from 'react-redux';
import Header from '../components/Header';

const mapStateToProps = (state: RootReducerState): AuthenticationState => {
  return {
    ...state.authentication
  }
}

export default connect(mapStateToProps)(Header);
